import * as Util from "../common/util";
import * as Data from "../interfaces/data";
import * as Translations from "../interfaces/translations";

// -------------------------------------------------------
// Add Customer
// -------------------------------------------------------
export interface ICustomerAddRequest {
    CustomerName: string;
    CustomerShortName: string;
    UserName: string;
    UserFirstName: string;
    UserLastName: string;
    UserEmail: string;
}

export interface ICustomerAddResponse {
    CustomerID: number;
    UserID: number;
    TemporaryPassword: string;

}

export function AddCustomer(request: ICustomerAddRequest): JQueryDeferred<Data.IResponse<ICustomerAddResponse>> {
    return Util.callWebService(
        "/api/Customer/Add",
        "POST",
        request);
}

// -------------------------------------------------------
// Edit Customer
// -------------------------------------------------------
export interface ICustomerEditMasterUser {
    ID: number;
    UserName: string;
    FullName: string;
    Email: string;
}

export interface ICustomerEditMaster {
    // editable fields
    Name: string;
    ShortName: string;
    LanguageID: number;
    CustomerLanguages: Translations.ILanguage[];
    AllLanguages: Translations.ILanguage[];

    // read-only fields
    ID: number;
    IsActive: boolean;
    Users?: ICustomerEditMasterUser[];
}

export function GetCustomer(customerID: number): JQueryDeferred<Data.IResponse<ICustomerEditMaster>> {
    return Util.callWebService(
        `/api/Customer/Get/${customerID}`,
        "GET");
}

export function SaveCustomer(request: ICustomerEditMaster): JQueryDeferred<Data.IResponse<ICustomerEditMaster>> {
    return Util.callWebService(
        "/api/Customer/Save",
        "POST",
        request);
}

// -------------------------------------------------------
// Change IsActive
// -------------------------------------------------------
export interface ICustomerChangeIsActiveRequest {
    CustomerID: number;
    IsActive: boolean;
}

export function ChangeIsActive(request: ICustomerChangeIsActiveRequest): JQueryDeferred<Data.IResponse<ICustomerEditMaster>> {
    return Util.callWebService(
        "/api/Customer/ChangeIsActive",
        "POST",
        request);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/customerData.ts